import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginChildrenRouter from './loginRouter/LoginChildrenRouter'
import HomeChildrenRouter from './homeRouter/home'
import UAChildrenRouter from './UARouter/UARouter'
import LeftviweChildrenRouter from './leftviweRouter/leftviweRouter'
import warehousemanagementChildrenRouter from './warehousemanagementRouter/warehousemanagementRouter'
import controloverinoicesChildrenRouter from './controloverinvoicesRouter/controloverinvoicesRouter'
import basucarchivemanageChildrenRouter from './basicarchivesmanagementRouter/basicarchivesmanagementRouter'
import homeComChildrenRouter from './ChannelRouter/homeComChildrenRouter/homeComChildrenRouter'
import cusPageChildrenRouter from './cusPageRouter/cuPageRouter'

Vue.use(VueRouter)

const home = r => require.ensure([], () => r(require('../views/home/home.vue')), 'home');
const login = r => require.ensure([], () => r(require('../views/login/login.vue')), 'login')
const systemmanagement = r => require.ensure([], () => r(require('../views/systemmanagement/systemmanagement.vue')), 'systemmanagement')
const leftviwe = r => require.ensure([], () => r(require('../views/interfacemanagement/views/leftviews/leftviews.vue')), 'leftviwe')
const warehousemanagement = r => require.ensure([], () => r(require('../views/warehousemanagement/warehousemanagement.vue')), 'warehousemanagement')
const controloverinvoices = r => require.ensure([], () => r(require('../views/controloverinvoices/controloverinvoices.vue')), 'controloverinvoices')
const basicarchivesmanagement = r => require.ensure([], () => r(require('../views/basicarchivesmanagement/basicarchivesmanagement.vue')), 'basicarchivesmanagement')
const homePage =  r => require.ensure([], () => r(require('../views/homePage/homePage.vue')), 'homePage')
const homeCom = r => require.ensure([], () => r(require('../views/views/home/homeCom.vue')), 'homeCom');
const ForgetPassword =  r => require.ensure([], () => r(require('../views/views/home/ForgetPassword/Password.vue')), 'ForgetPassword');
const cusPage =  r => require.ensure([], () => r(require('../views/cusPage/cusPage.vue')), 'cusPage');
const AORcode =  r => require.ensure([], () => r(require('../views/AORcode/index.vue')), 'AORcode');



const routes = [{
		path: '/',
		name: 'login',
		component: login,
		children: LoginChildrenRouter,
		 meta: {
            typePage: 1
        }
	},
	{
		path: '/home',
		name: 'home',
		component: home,
		children: HomeChildrenRouter,
		 meta: {
            typePage: 1
        }
	},
	{
		path: '/UA',
		name: 'UA',
		component: systemmanagement,
		children: UAChildrenRouter
	},
	{
		path: '/leftviwe',
		name: 'leftviwe',
		component: leftviwe,
		children: LeftviweChildrenRouter
	},
	{
		path: '/warehousemanagement',
		name: 'warehousemanagement',
		component: warehousemanagement,
		children: warehousemanagementChildrenRouter
	},
	{
		path: '/controloverinvoices',
		name: 'controloverinvoices',
		component: controloverinvoices,
		children: controloverinoicesChildrenRouter
	},
	{
		path: '/basicarchivesmanagement',
		name: 'basicarchivesmanagement',
		component: basicarchivesmanagement,
		children: basucarchivemanageChildrenRouter
	},
	{
		path: '/homePage',
		name: 'homePage',
		component: homePage,
		meta: {
            typePage: 2
        }
	},
	{
		path: '/homeCom',
		name: 'homeCom',
		component: homeCom,
		children: homeComChildrenRouter
	},
	{
		path: '/ForgetPassword',
		name: 'ForgetPassword',
		component: ForgetPassword,
	},
	{
		path: '/cusPage',
		name: 'cusPage',
		component: cusPage,
		children: cusPageChildrenRouter
	},
	{
		path: '/AORcode',
		name: 'AORcode',
		component: AORcode,
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	}
})
// 防止重复点击路由
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default router